define([
    "underscore",
    "backbone",
    "backbone.form"
], function (_, Backbone) {
    return Backbone.Form.extend({
        url: "/rest_account/validate_additional_account_form",

        validation: {
            member_type_cd: {
                required: true,
                pattern: 'number'
            },
            currency_cd: {
                required: true,
                pattern: 'number'
            },
            leverage: {
                required: true
            },
            referral_ib: {
                required: false,
                min: 1000
            },
            password: {
                required: true
            },
            confirm_password: {
                equalTo: 'password'
            },
            terms_chk: {
                acceptance: true
            },
            warning_chk: {
                acceptance: true
            },
        },

        labels: {
            member_type_cd: "Account Type",
            // promotion_cd: "Account Type",
            currency_cd: "Currency",
            leverage: "Leverage",
            terms_chk: "TC",
            warning_chk: "Warning",
            password: "Password",
            confirm_password: "Confirm Password",
            referral_ib: "Referral IB"
        }
    });
});
